var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhoWantsScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Kim 1000 Puan \\u0130ster",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF8DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8338F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE176A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kp-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F65AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C21E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp-gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7C230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C98207"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp-base",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3E4560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp-coin",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7C230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D08A07"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "kp-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "kp-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#4A0028",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kp-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#4A0028",
    opacity: 0.4,
    filter: "url(#kp-bsh)",
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#82104D",
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kp-face)",
    d: "M226.6,35.0 Q256.0,18.0 285.4,35.0 L432.7,120.0 Q462.1,137.0 462.1,171.0 L462.1,341.0 Q462.1,375.0 432.7,392.0 L285.4,477.0 Q256.0,494.0 226.6,477.0 L79.3,392.0 Q49.9,375.0 49.9,341.0 L49.9,171.0 Q49.9,137.0 79.3,120.0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#82104D",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#kp-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kp-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#kp-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#kp-osh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,190 C138,190 136,254 190,262",
    fill: "none",
    stroke: "#C98207",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,190 C374,190 376,254 322,262",
    fill: "none",
    stroke: "#C98207",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,186 C140,186 138,248 190,256",
    fill: "none",
    stroke: "url(#kp-gold)",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,186 C372,186 374,248 322,256",
    fill: "none",
    stroke: "url(#kp-gold)",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 292,
    width: 24,
    height: 42,
    fill: "#D9970E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 292,
    width: 6,
    height: 42,
    fill: "#FFF0A0",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,172 H336 V210 C336,266 302,300 256,300 C210,300 176,266 176,210 Z",
    fill: "url(#kp-gold)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 172,
    rx: 80,
    ry: 11,
    fill: "#FFF3B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 174,
    rx: 68,
    ry: 6,
    fill: "#D9970E",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,194 C196,240 208,268 228,284",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.65,
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 258,
    y: 268,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 70,
    fill: "#A86A05"
  }, "?"), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 264,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 70,
    fill: "#FFFFFF"
  }, "?"), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 332,
    width: 104,
    height: 22,
    rx: 6,
    fill: "url(#kp-gold)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 358,
    width: 140,
    height: 30,
    rx: 8,
    fill: "#141826"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 352,
    width: 140,
    height: 30,
    rx: 8,
    fill: "url(#kp-base)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 360,
    width: 68,
    height: 14,
    rx: 3,
    fill: "url(#kp-gold)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 355,
    width: 110,
    height: 4,
    rx: 2,
    fill: "#FFFFFF",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 352,
    r: 30,
    fill: "#A86A05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 346,
    r: 30,
    fill: "url(#kp-coin)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 346,
    r: 22,
    fill: "none",
    stroke: "#FFF2B0",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(360 348) scale(13)",
    fill: "#C98207",
    d: "M0.0,-1.0 L0.24,-0.33 L0.95,-0.31 L0.39,0.13 L0.59,0.81 L0.0,0.42 L-0.59,0.81 L-0.39,0.13 L-0.95,-0.31 L-0.24,-0.33 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 362,
    r: 24,
    fill: "#A86A05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 357,
    r: 24,
    fill: "url(#kp-coin)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 357,
    r: 17,
    fill: "none",
    stroke: "#FFF2B0",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(152 359) scale(10)",
    fill: "#C98207",
    d: "M0.0,-1.0 L0.24,-0.33 L0.95,-0.31 L0.39,0.13 L0.59,0.81 L0.0,0.42 L-0.59,0.81 L-0.39,0.13 L-0.95,-0.31 L-0.24,-0.33 Z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(372 160) scale(18)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(138 160) scale(12)",
    fill: "#FFFFFF",
    opacity: 0.9,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(392 268) scale(9)",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoWantsScore);
export default __webpack_public_path__ + "static/media/who-wants-score.5189df9b4de2e22ba5750aa9dff6df59.svg";
export { ForwardRef as ReactComponent };